export default "__VITE_ASSET__CkV4iQVq__"